/**
 * In use loops (sections/pl-loops, and clips in the product gallery: snippets/pl-gallery-extra). Each tile shows a
 * still; once it is on screen the GIF-style loop (an animated WebP) swaps in and plays. The button pauses it, back to
 * the still (WCAG 2.2.2: moving content can be paused). With reduced motion or data saver on it waits for a tap on
 * play. Off screen (or in a hidden gallery frame) it rests on the still. Safe to include more than once.
 */
(() => {
  const tiles = document.querySelectorAll('[data-pl-loop]:not([data-pl-loop-ready])');
  if (!tiles.length) return;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  const auto = !reduce && !saveData;

  tiles.forEach((tile) => {
    tile.setAttribute('data-pl-loop-ready', '');
    const img = tile.querySelector('img');
    const btn = tile.querySelector('[data-pl-loop-play]');
    let userPaused = false;

    const set = (playing) => {
      const want = playing ? img.dataset.loop : img.dataset.poster;
      if (img.getAttribute('src') !== want) img.setAttribute('src', want);
      tile.classList.toggle('is-playing', playing);
      btn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    };

    btn.addEventListener('click', () => {
      const playing = tile.classList.contains('is-playing');
      userPaused = playing;
      set(!playing);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const inView = entries.some((e) => e.isIntersecting);
        if (inView && auto && !userPaused) set(true);
        else if (!inView && tile.classList.contains('is-playing')) set(false);
      }, {threshold: 0.35}).observe(tile);
    } else if (auto) {
      set(true);
    }
  });
})();
